import React from 'react';
const ShowOtherFootprint = ({title,value}) => {
  // Conversion function
  try {
    return (
      <div className="flex justify-center items-center bg-white rounded-2xl px-0 pt-2 pb-1 w-full mx-auto border border-gray-200 print:bg-white">
        <div className="flex flex-col items-center justify-center">
          <p className="text-sm text-gray-500 tracking-normal text-center" style={{ margin: 0 }}>
            {title}
          </p>
          <p className={`text-gray-800 text-lg mobile:text-xl font-bold mt-0 text-center`}  style={{ margin: 0 }}>
            {value || "-"}
          </p>
        </div>
      </div>
    );
  } catch (error) {
    return (
      <div className="flex justify-center items-center bg-white border border-gray-200 rounded-full p-5 my-4 w-full mx-auto">
        <p>-</p>
      </div>
    );
  }
};

export default ShowOtherFootprint;
